import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';

import Table from '../components/table';
import Switch from '../components/switch/main';
import FiltersForm from '../components/filters/main';
import CreateTransaction from '../components/forms/transaction/main';
import CreatePayout from '../components/forms/create-payout/main';
import FraudPopup from '../components/popups/fraud/main';
import PaymentDate from '../components/popups/payment-date/main';
import Calendar from '../../shared/calendar/main';
import Filters from '../../shared/filters/main';

import { selectors as rootSelectors } from '../../root';

const CreatePayoutForm = CreatePayout('payoutsListCreatePayoutForm');
const TransactionForm = CreateTransaction('payoutsListTransactionForm');

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content payouts-list">
				<div className="container__content-title">
					<Switch {...props} />
				</div>
				<div className="container__content-body">
					<div className="payouts-list__filter-position clearfix">
						<Filters {...props} {...props.filters} />
					</div>

					<div className="ui-control-bar">
						<div className="ui-control-bar__item modify-item---status">
							<div className="ui-control-bar__item-position">
								<FiltersForm
									{...props}
									initialValues={props.filtersFormData.initialValues}
									enableReinitialize={true}
									keepDirtyOnReinitialize={true}
								/>
							</div>
						</div>

						<div className="ui-control-bar__item modify-item---calendar">
							<div className="ui-control-bar__item-position">
								<Calendar
									{...props.calendar}
									onInit={props.calendarInit}
									onToggle={props.calendarToggle}
									onChange={props.calendarChange}
									onApply={props.calendarApply}
									intl={props.intl}
								/>
							</div>
						</div>

						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								{props.can('createTransaction') && (
									<button className="ui-btn ui-btn-primary toggle-transaction" onClick={props.toggleTransactionForm}>
										<span>{props.intl('Transfer money')}</span>
									</button>
								)}
								{props.can('create') && (
									<button
										className="ui-btn ui-btn-primary toggle-create-payout"
										onClick={props.toggleCreatePayoutForm}
									>
										<span>{props.intl('Create payout')}</span>
									</button>
								)}
								<button className="ui-btn ui-btn-primary export" onClick={props.export}>
									<span>{props.intl('Export')}</span>
								</button>
								<button className="ui-btn ui-btn-primary apply" onClick={props.apply}>
									<span>{props.intl('Apply')}</span>
								</button>
								<button className="ui-btn ui-btn-secondary clear" onClick={props.clear} />
							</div>
						</div>
					</div>
					<Table
						rows={props.data || []}
						sorting={props.sorting}
						sort={props.sortColumn}
						actions={{
							changeUrgency: props.changeUrgency,
							approve: props.approve,
							confirm: props.confirm,
							reject: props.reject
						}}
						payoutSystem={props.activePayoutSystem}
					/>
					<div className="payouts-list__transaction-form-position">
						<TransactionForm {...props} initialValues={props.transactionFormData.initialValues} />
						<CreatePayoutForm {...props} initialValues={props.createPayoutFormData.initialValues} />
						<CreatePayoutForm {...props} initialValues={props.createPayoutFormData.initialValues} />
						<FraudPopup {...props} />
						<PaymentDate {...props} />
					</div>
				</div>
			</div>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		adminEmail: selectors.getAdminEmail(state),
		calendar: selectors.getCalendar(state),
		filtersFormData: selectors.getFiltersFormData(state),
		transactionFormData: selectors.getTransactionFormData(state),
		transactionShouldShowStatus: selectors.getTransactionShouldShowStatus(state),
		createPayoutFormData: selectors.getCreatePayoutFormData(state),
		createPayoutShouldShowStatus: selectors.getCreatePayoutShouldShowStatus(state),
		payoutSystems: selectors.getPayoutSystems(state),
		groupedPayoutSystems: selectors.getGroupedPayoutSystems(state),
		systemBalances: selectors.getSystemBalances(state),
		payoutStatusesEnum: selectors.getPayoutStatusesEnum(state),
		activePayoutSystem: selectors.getActivePayoutSystem(state),
		activePayoutSystemId: selectors.getActivePayoutSystemId(state),
		payoutSystemCategoriesList: selectors.getPayoutSystemCategoriesList(state),
		activePayoutSystemCategories: selectors.getActivePayoutSystemCategories(state),
		can: selectors.getCan(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		intl: selectors.getIntl(state),
		progressBar: selectors.getProgressBar(state),
		filters: selectors.getFilters(state),
		sorting: selectors.getSorting(state),
		isFraudPopupVisible: selectors.getIsFraudPopupVisible(state),
		isPaymentDatePopupVisible: selectors.getIsPaymentDatePopupVisible(state),
		paidAtFormPendingPayout: selectors.getpaidAtFormPendingPayout(state),
		payoutsToReject: selectors.getPayoutsToReject(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/list/main.js